'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadPackData = loadPackData;
exports.downloadPack = downloadPack;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PACK_LOAD = 'ms/pack/pack_load';
var PACK_LOAD_SUCCESS = 'ms/pack/pack_load_success';
var PACK_LOAD_FAIL = 'ms/pack/pack_load_fail';
var PACK_DOWNLOAD = 'ms/pack/pack_download';
var PACK_DOWNLOAD_SUCCESS = 'ms/pack/pack_download_success';
var PACK_DOWNLOAD_FAIL = 'ms/pack/pack_download_fail';

var initialState = {
  data: null,
  loading: false,
  error: null,
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case PACK_LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true,
        error: false,
        loaded: false
      });
    case PACK_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        data: action.result,
        loading: false,
        loaded: true,
        error: null
      });

    case PACK_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });

    default:
      return state;
  }
}

// Action creators
function loadPackData(pack) {
  return {
    types: [PACK_LOAD, PACK_LOAD_SUCCESS, PACK_LOAD_FAIL],
    promise: loadPack(pack)
  };
}

function downloadPack(packId, body) {
  return {
    types: [PACK_DOWNLOAD, PACK_DOWNLOAD_SUCCESS, PACK_DOWNLOAD_FAIL],
    promise: download(packId, body)
  };
}

// Private
function loadPack(packId) {
  return function (client) {
    var loadingPromise = client.get('v1/packs/' + packId).then(function (result) {
      return result;
    });

    return loadingPromise;
  };
}

// Download the pack file
// pack: packId
// body: config object {resolution:number, mesh_format:str, image_format:str, additional_files: bool}
function download(packId, body) {
  return function (client) {
    var loadingPromise = client.post('/v1/packs/' + packId + '/zip', { data: body }).then(function (result) {
      if (result && result.url) window.location = result.url;
    });

    return loadingPromise;
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/pack.js
// module id = 1002
// module chunks = 0